import { useState } from "@wordpress/element";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import find from "lodash/find";
import googlePlaceService from "services/googlePlaceService/GooglePlaceService";

const AddressSearch = () => {
	const countryList = useSelector(({ vino }) => vino.lookups.countryList);
	const { setValue, watch } = useFormContext();
	const [selectedValue, setSelectedValue] = useState("");
	const [inputValue, setInputValue] = useState("");
	const [options, setOptions] = useState([]);
	const watchAddress = watch("address");

	const handleChange = async (value) => {
		const result = await googlePlaceService.suggest(value);
		setOptions(result.predictions);
	};

	const handleSelect = async (value) => {
		const { place_id } = value;
		const place = await googlePlaceService.findPlace(place_id);
		if (place.status === "OK") {
			const { result } = place;
			const address = {
				...watchAddress,
			};

			if (result.address_components) {
				let stateCode = null;
				result.address_components.forEach((addressComponent) => {
					const { types, long_name, short_name } = addressComponent;

					if (types.includes("street_number")) {
						address.addressLine1 = long_name;
					} else if (types.includes("route")) {
						address.addressLine1 = `${address.addressLine1} ${long_name}`;
						address.addressLine2 = "";
					} else if (types.includes("locality")) {
						address.city = long_name;
					} else if (types.includes("administrative_area_level_1")) {
						stateCode = short_name;
					} else if (types.includes("country")) {
						const country = findCountry(short_name);

						if (country) {
							address.countryId = country.id;
							const state = findState(country, stateCode);
							if (state) {
								address.stateId = state.id;
							}
						}
					} else if (types.includes("postal_code")) {
						address.zipCode = long_name;
					}
				});
				setValue("address", address);
			}
		}
	};

	const findCountry = (code) => {
		return find(countryList, { code });
	};

	const findState = (country, code) => {
		if (country) {
			const stateList = country.states.nodes;
			return find(stateList, { code });
		}
	};

	if (!countryList.length) {
		return null;
	}

	return (
		<>
			<Autocomplete
				value={selectedValue}
				onChange={(event, newValue) => {
					setSelectedValue(newValue);
					handleSelect(newValue);
				}}
				getOptionLabel={(option) =>
					typeof option === "string" ? option : option.description
				}
				filterOptions={(x) => x}
				inputValue={inputValue}
				includeInputInList
				filterSelectedOptions
				onInputChange={(event, newInputValue) => {
					setInputValue(newInputValue);
					handleChange(newInputValue);
				}}
				options={options}
				renderInput={(params) => (
					<TextField {...params} label="Search location" />
				)}
			/>
		</>
	);
};

export default AddressSearch;
